import React, { useEffect, useState } from 'react';
import { YStack } from 'tamagui';

import { WeatherHighLowCard } from './components/WeatherHighLowCard';
import { WeatherHighLowCardSkeleton } from './components/WeatherHighLowCardSkeleton';
import { WeatherUpcomingWeatherCard } from './components/WeatherUpcomingWeatherCard';
import { WeatherUpcomingWeatherCardSkeleton } from './components/WeatherUpcomingWeatherCardSkeleton';
import { WeatherUVIndexCard } from './components/WeatherUVIndexCard';
import { WeatherUVIndexCardSkeleton } from './components/WeatherUVIndexCardSkeleton';
import { DraggableScrollView } from '../../components/common/DraggableScrollView';
import { useGetWeatherData } from '../../hooks/weather/useGetWeatherData';
import { WeatherData } from '../../types/Weather';

export const Weather: React.FC = () => {
  const [weatherData, setWeatherData] = useState<WeatherData | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const { getWeather } = useGetWeatherData();

  useEffect(() => {
    const fetchWeatherData = async () => {
      setIsLoading(true);
      try {
        const data = await getWeather();
        setWeatherData(data);
      } catch (error) {
        console.error('Error fetching weather data:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchWeatherData();
  }, []);

  return (
    <YStack flex={1} backgroundColor="#161616">
      <DraggableScrollView>
        {isLoading ? (
          <>
            <WeatherHighLowCardSkeleton />
            <WeatherUpcomingWeatherCardSkeleton />
            <WeatherUVIndexCardSkeleton />
          </>
        ) : (
          <>
            {weatherData?.todayHighLow && <WeatherHighLowCard {...weatherData.todayHighLow} />}
            {weatherData?.upcoming && <WeatherUpcomingWeatherCard {...weatherData.upcoming} />}
            {weatherData?.uvIndex && <WeatherUVIndexCard {...weatherData.uvIndex} />}
          </>
        )}
      </DraggableScrollView>
    </YStack>
  );
};
